module.exports = __webpack_public_path__ + "img/Nathan@2x.85eb1ebc.png";